import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { trigger, style, animate, transition } from "@angular/animations";
import { WindowSizeDirective } from 'src/app/shared/directives/window-size.directive';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LpCreateEventComponent } from './components/lp-create-event/lp-create-event.component';
import { LpMenuComponent } from './components/lp-menu/lp-menu.component';
import { LpFooterComponent } from './components/lp-footer/lp-footer.component';
import { ButtonModule } from 'primeng/button';
import { NgxMasonryModule } from 'ngx-masonry';
import { collapseAnimation } from 'src/app/shared/animations/collapse.animation';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { LpPricingVariantsComponent } from './components/lp-pricing-variants/lp-pricing-variants.component';

export const fadeAnimation = [
  trigger(
    'enterAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        animate('1000ms', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({ opacity: 1}),
        animate('1000ms', style({ opacity: 0}))
      ])
    ]
  )
];
export enum FadeAnimationState {
  IN = "in",
  OUT = "out"
};

interface IFaqItem {
  title: string;
  text: string;
  active: boolean;
}

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    CommonModule, NgOptimizedImage,
    ButtonModule,
    LpCreateEventComponent, LpMenuComponent, LpFooterComponent, LpPricingVariantsComponent,
    NgxMasonryModule
  ],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  animations: [ fadeAnimation, collapseAnimation ],
  hostDirectives: [ WindowSizeDirective ]
})
export class LandingPageComponent implements OnInit, OnDestroy {

  heroImageArray = [
    "assets/images/lp/lp-1.png",
    "assets/images/lp/lp-2.jpg",
    "assets/images/lp/lp-3.png",
    "assets/images/lp/lp-4.png",
    "assets/images/lp/lp-5.jpg",
  ];
  heroTextArray = [
    "vzdělávacích kurzů",
    "tanečních kurzů a festivalů",
    "kurzů pro děti",
    "konferencí",
    "online lekcí"
  ];
  heroActiveImage: string = this.heroImageArray[0];
  heroActiveText: string = this.heroTextArray[0];
  magicText: string = ' ';
  private heroIndex: number = 1;

  updateMasonryLayout: boolean = false;

  hideWhomSection = true;

  faqItems: IFaqItem[] = [
    {
      title: 'Potřebuji mít pro prodej kurzů vlastní web?',
      text: 'Ne. Pro samotný prodej kurzů a podobných akcí není potřeba investovat čas a peníze do vlastního webu. Lektory.app vytvoří prodejní stránku za vás. Stačí si vybrat z předpřipravených šablon nákupních procesů, dále nastavíte popis akce, cenu a číslo bankovního účtu, kam budou chodit platby vašich zákazníků.',
      active: false
    },
    {
      title: 'Jak náročné je integrovat Lektory.app do našeho stávajícího webu?',
      text: 'Základní integrace je snadná a spočívá ve vložení dvou řádků našeho kódu do vašeho webu. Zvládne ji poučený správce webu. V případě potřeby s integrací pomůžeme. Specifická úprava designu našich widgetů, může trvat řádově několik hodin zkušenému kóderovi webů.',
      active: false
    },
    {
      title: 'Co vše potřebuji pro prodej mých kurzů pomocí Lektory?',
      text: 'Potřebujete mít zřízený bankovní účet, pro příjem plateb od klientů a IČ své právní entity.',
      active: false
    },
    {
      title: 'Lze přijímat platby v různých měnách?',
      text: 'Podporujeme nastavení cen a příjem plateb v EUR a CZK.',
      active: false
    },
    {
      title: 'Budou mi chodit peníze od zákazníků přímo na účet nebo přes vás?',
      text: 'Platby vašich zákazníků chodí přímo na váš účet. Alternativní možností je využití některé z platebních bran.',
      active: false
    },
  ]

  constructor(
    private modalService: ModalService,
    private navService: NavigationService
  ) { }

  ngOnInit(): void {
    this.doMagicText();
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.hideWhomSection = false;
      this.updateMasonryLayout = true;
    })
  }

  onArrangeDemo() {
    this.navService.goToArrangeMeeting();
  }

  onHeroAnimationDone(b: boolean) {
    if (b) {
      setTimeout(() => {
        this.changeAnimationToNext();
      },5000)
    }
  }

  changeAnimationToNext() {
    if (this.heroIndex == this.heroImageArray.length) this.heroIndex = 0;
    this.heroActiveImage = this.heroImageArray[this.heroIndex];
    this.heroActiveText = this.heroTextArray[this.heroIndex];
    this.doMagicText();

    this.heroIndex++;
  }

  doMagicText() {
    this.magicText = this.heroActiveText[0];

    let index = 1;
    const interval = setInterval(() => {
      this.magicText += this.heroActiveText[index];
      index++;
      if (index >= this.heroActiveText.length) clearInterval(interval);
    }, 80);
  }

  ngOnDestroy(): void {
  }
}
